let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dvErj")).then(() => parcelRequire('7zgXj'));